<template>
  <div>

    <!-- row for page heading -->
    <v-row class="mx-4 mt-2">
      <v-col cols="12" md="4">
        <h2 class="text-left">Apply Leave</h2>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

		<!-- row for page body in the card -->
    <v-form v-model="form">
    <v-row>
      <v-col cols="12" md="12" sm="12">

        <v-card class="ma-3">

          <v-row class="pa-3" >
						
						<!-- left side fields col -->
            <v-col cols="12" md="6" class="pa-6">
							
              <!-- row for staff and selector -->
              <v-row class="my-1">
								
                <v-col cols="12" md="6" align-self="center">
                  <span class="mt-4">Staff *:</span>
                </v-col>

                <v-col cols="12" md="6" align-self="center">
                  <div>
                      <v-autocomplete
                        dense
                        filled
                        rounded
                        solo
                        :items="ownView"
                        item-value="id"
                        item-text="full_name"
                        label="Select Staff"
                        v-model="leave.staff_id"
                        class="font-weight-bold rounded-input"
                        hide-details
                        clearable
                        @change="leave.leave_type = leave.start_date = leave.end_date = selectedLeaveSpan = leaveAllowanceStats = null"
                        :rules="[rules.required]"
                      >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.full_name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="
                            data.item.username +
                            (data.item.employee_id
                              ? ` (${data.item.employee_id})`
                              : '')
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
                  </div>
                </v-col>
								
              </v-row>

              <!-- row for leave selector -->
              <v-row class="my-1">

                 <v-col cols="12" md="6" align-self="center">
                  <span class="mt-4">Leave Type *:</span>
                </v-col>

                <v-col cols="12" md="6" align-self="center">
                  <div>
                    <v-autocomplete
                      dense
                      filled
                      rounded
                      solo
                      label="Select Leave Type"
                      :items="leaveTypes"
                      v-model="leave.leave_type"
                      item-text="title"
                      item-value="id"
                      class="font-weight-bold rounded-input"
                      hide-details
                      clearable
                      :disabled="!leave.staff_id"
                      @change="leave.is_half_day = true; selectedLeaveSpan = leave.start_date = leave.end_date = leaveAllowanceStats = null; getLeaveAllowanceForLeaveType();"
                      @click:clear="staffLeaveAllowance = null"
                      :rules="[rules.required]"
                    >
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="my-1">

                 <v-col cols="12" md="6" align-self="center">
                  <span class="mt-4">Leave Span *:</span>
                </v-col>

                <v-col cols="12" md="6" align-self="center">
                  <div>
                    <v-autocomplete
                      dense
                      filled
                      rounded
                      solo
                      label="Choose Leave Span"
                      :items="leaveSpans"
                      v-model="selectedLeaveSpan"
                      class="font-weight-bold rounded-input"
                      hide-details
                      return-object
                      clearable
                      @change="leave.is_half_day=false; leave.start_date = leave.end_date = leaveAllowanceStats = null; handleTourAfterSelect();"
                      :disabled="!leave.staff_id || !staffLeaveAllowance"
                      :rules="[rules.required]"
                    >
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- row for leave type -->
              <v-row class="my-1" v-if="selectedLeaveSpan == 'Single'"  id="leave-duration">

                <v-col cols="12" md="6" align-self="center">
                  <span class="mt-4">Leave Duration *:</span>
                </v-col>

                <v-col cols="" md="" sm="6" align-self="center">
                  <div>
                    <v-autocomplete
                      dense
                      filled
                      rounded
                      solo
                      label="Select Leave Duration"
                      :items="leaveDurations"
                      v-model="leave.is_half_day"
                      item-text="label"
                      item-value="value"
                      class="font-weight-bold rounded-input"
                      hide-details
                      clearable
                      :disabled="!leave.staff_id"
                      @change="leave.start_date = leave.end_date = leaveAllowanceStats = null"
                    >
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- row for single leave date selector -->
              <v-row class="my-1" v-if="selectedLeaveSpan == 'Single'" id="single-leave-span">

                <v-col cols="" md="" sm="6" align-self="center">
                  <p class="my-1">Date *:</p>
                </v-col>

                <v-col cols="" md="" sm="6" align-self="center">
                  <v-menu
                    ref="singleDatePicker"
                    v-model="singleDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="leave.start_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(leave.start_date)"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="leave.start_date" 
                      no-title scrollable
                      :disabled="!leave.staff_id"
                      :min="staffLeaveAllowance.validity[0]"
                      :max="staffLeaveAllowance.validity[1]"
                      @change="getLeaveStatsForApplying"
                      :events="getDateEvents"
                      event-color="primary"
                    >

                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="singleDateMenu = false"
                        :disabled="!leave.staff_id"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.singleDatePicker.save(leave.start_date)"
                        :disabled="!leave.staff_id"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

              </v-row>

              <!-- row for start and end date pickers -->
              <v-row class="my-1" v-if="selectedLeaveSpan == 'Multiple'" id="multi-leave-span">

                <v-col cols="" md="" sm="6" align-self="center">
                  <p class="my-1">Date *:</p>
                </v-col>

                <!-- start date picker -->
                <v-col cols="" md="" sm="3" align-self="center">
                  <v-menu
                    ref="startDatePicker"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="leave.start_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(leave.start_date)"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                      :min="staffLeaveAllowance.validity[0]"
                      :max="staffLeaveAllowance.validity[1]"
                      v-model="leave.start_date" 
                      no-title scrollable
                      :disabled="!leave.staff_id"
                      @change="getLeaveStatsForApplying"
                      :events="getDateEvents"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="startDateMenu = false"
                        :disabled="!leave.staff_id"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.startDatePicker.save(leave.start_date)"
                        :disabled="!leave.staff_id"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- end date picker -->
                <v-col cols="" md="" sm="3" align-self="center">
                  <v-menu
                    ref="endDatePicker"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="leave.end_date"
                    ransition="scale-transition"
                    offset-y
                    min-width="auto"
                    :disabled="!leave.start_date"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDate(leave.end_date)"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!leave.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="leave.end_date" 
                      :min="leave.start_date"
                      :max="staffLeaveAllowance.validity[1]"
                      no-title scrollable
                      :disabled="!leave.staff_id"
                      @change="getLeaveStatsForApplying"
                      :events="getDateEvents"

                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary" 
                        @click="endDateMenu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.endDatePicker.save(leave.end_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-divider></v-divider>

              <!-- row for showing total leaves -->
              <v-row class="grey lighten-4 my-2">
                <v-col align-self="center">
                  <b>
                    Total
                  </b>
                </v-col>

                <v-col align-self="center">
                  <!-- show date difference -->
                  <b>
                    {{ (selectedLeaveType == 'Single') ? 1 + ' ' : '' }}
                    {{ leaveAllowanceStats ? leaveAllowanceStats.total_days : "-" }}
                    Day(s) 
                    <v-tooltip v-if="leaveAllowanceStats" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2"
                            >
                            mdi-help-circle
                          </v-icon>
                        </template>
                        <span>This is calculated by excluding the staff holidays and week-offs from the requested leave duration.</span>
                    </v-tooltip>
                  </b>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col align-self="center">
                  Note *:
                </v-col>

                <v-col align-self="center">
                  <v-textarea
                    label="Notes"
                    v-model="leave.notes"
                    :rules="[rules.required]"
                    :disabled="!leave.staff_id"
                    rows="2"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>

            </v-col>

						<v-spacer></v-spacer>

            <!-- right side cards col -->
            <v-col cols="12" md="5" class="pa-6">
              <v-col justify="space-around">
                <!-- first card -->
                <v-card class="pa-3 mb-3" id="allowed-leaves">
									<!-- heading for data -->
									<v-row justify="space-around">
										<v-col cols="" md="" sm="6">
											<b>
												As of <span>{{ moment(new Date()).format('LL') }}</span> 
											</b>
										</v-col>
									</v-row>

									<!-- stat 1 -->
									<v-row>
										<v-col cols="">
											Total Allowed
										</v-col>
										<v-divider vertical inset></v-divider>
										<v-col cols="">
                      {{ staffLeaveAllowance? staffLeaveAllowance.allowed_days : '-' }}
										</v-col>
									</v-row>

									<!-- stat 2 -->
									<v-row>
										<v-col cols="">
											Balance 
										</v-col>
										<v-divider vertical inset></v-divider>
										<v-col cols="">
                      {{ staffLeaveAllowance ? staffLeaveAllowance.balance : '-'}}
										</v-col>
									</v-row>

									<!-- stat 3 -->
									<!-- <v-row>
										<v-col cols="">
											Balance after booked leave
										</v-col>
										<v-divider vertical inset></v-divider>
										<v-col cols="">
											{{ leaveAllowanceStats ? leaveAllowanceStats.estimated_balance : "-" }}
										</v-col>
									</v-row> -->

                </v-card>
              </v-col>

              <v-col justify="space-around" v-if="staffLeaveAllowance && leaveAllowanceStats">
                <v-card class="pa-3">
									<v-row justify="center">
										<v-col cols="" md="">
											<b>
												As of {{ moment(staffLeaveAllowance.validity[1]).format("LL") }}
											</b>
										</v-col>
										
									</v-row>

									<v-row>
										<v-col cols="">
											Estimated Balance
										</v-col>
										<v-divider vertical inset></v-divider>
										<v-col cols="">
                      <span :class="leaveAllowanceStats.estimated_balance < 0 ? 'red--text' : 'black--text'">{{ leaveAllowanceStats ? leaveAllowanceStats.estimated_balance : '-' }}</span>
										</v-col>
									</v-row>

                </v-card>
              </v-col>

            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <p v-if="(leaveAllowanceStats && leaveAllowanceStats.estimated_balance < 0)" class="red--text mt-2">Your requested leave duration exceeds your leave allowance balance.</p> 
              <v-btn @click="submitLeaveDetails" :disabled="!form || (leaveAllowanceStats && leaveAllowanceStats.estimated_balance < 0) || !leaveAllowanceStats" color="primary">
                SUBMIT
              </v-btn>
            </v-col>

            <v-col>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
    </v-form>
    <!-- </v-row> -->

    <!-- snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      timeout="4000"
      :color="snackbar.color"
      multi-line
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import Helper from '@utils/misc';
import TourHelper from "@utils/tour_helper";


export default {
  name: "ApplyLeave",

  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },

      moment: moment,
      form: false,

      // for single leave
      singleDateMenu: false,
      singleDate: null,

      // for multiple leave
      // start date
      startDateMenu: false,
      startDate: null,
      // end date
      endDate: null,
      endDateMenu: false,

      // dateDifference: null,

      // current_month_year: { // store current month,year
      // 	month: null,
      // 	year: null,
      // },

      // dummy staff names
      allStaff: [],

      // dummy status names
      leaveStatusNames: ["Pending", "Approved", "Rejected"],
      selectedStatus: null,

      selectedLeaveName: null,

      staffLeaveAllowance: null,
      
      leaveAllowanceStats: null,

      leaveDurations: [
        {
          label: 'Full Day',
          value: false,
        },
        {
          label: 'Half Day',
          value: true,
        }
      ],

      staffHolidays: [],

      // dummy leave duration
      leaveSpans: ['Single', 'Multiple'],
      selectedLeaveSpan: null,

      // dummy leave type
      leaveTypes: [],
      selectedLeaveType: null,

      // final leave object
      leave: {
        staff_id: null,
        is_half_day: false,
        start_date: null,
        end_date: null,
        notes: null
      },
      rules: {
        required: (v) => !!v || "Required",
      }
    };
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },

    ownView(){
      if(this.allStaff.length == 0) return [];
      if(!this.currentUser.privileges.canApplyLeaveForAnyStaff){
        return this.allStaff.filter(x => x.id == this.currentUser.id);
      }else{
        return this.allStaff;
      }
    },

  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Apply Leave", description: "Apply your leave by selecting staff, leave type and span", videoLink: "https://youtube.com"});
        TourHelper.startTour(this, "apply__leave", steps);
    },

    handleTourAfterSelect() {
        var steps = [];
        // steps.push({id: '1', title: "Apply Leave", description: "Apply your leave by selecting staff, leave type and span", videoLink: "https://youtube.com"});
        steps.push({id: '1', description: "Specify whether leaves are full day or half day", el: '#leave-duration'});
        steps.push({id: '2', description: "Select date for single leave span", el: '#single-leave-span'});
        steps.push({id: '3', description: "Select start date and end date for multiple leave span", el: '#multi-leave-span'});
        steps.push({id: '4', description: "verify your leave balance after filling information", el: '#allowed-leaves'});
        TourHelper.startTour(this, "apply__leave__after__select", steps);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
        if(err.response.status == 409) {
          this.snackbar.text = "The selected leave dates are overlapping an existing leave";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // display selected date in D MMM YYYY format
    formattedDate(date) {
      if (!date) return "";

      return moment(date, "YYYY-MM-DD").format("ll");
    },

    // get all leave stats for staff
    // getLeaveStats() {
      
    // },

    // get staff details
    async getAllStaff() {
      var url = Helper.addUrlParams(endpoints.getAllStaff, "all=true");
      this.allStaff = await api.call(this.apiEssentials, url);
    },

    async getAllLeaveTypes() {
      this.leaveTypes = await api.call(this.apiEssentials, endpoints.staffLeaveTypes);
    },

    async getLeaveAllowanceForLeaveType() {
      if(this.leave.leave_type && this.leave.staff_id){
        var response = await api.call(this.apiEssentials, Helper.addUrlParams(endpoints.getAllStaffLeaveAllowances, ["leave_type_id=" + this.leave.leave_type, "staff_id=" + this.leave.staff_id]));
        if (response == null){
          this.snackbar.text = "This staff does not have an allocated Attendance Category. You can allocate it by going to Staff Settings";
          this.snackbar.color = "red";
          this.snackbar.visible = true;
          this.leave.staff_id = null;
          return;
        }
        this.staffLeaveAllowance = response;
        this.getRangeHolidays();

     }

    },

    async getLeaveStatsForApplying() {
      if(this.selectedLeaveSpan == 'Single' && !this.leave.start_date) return;
      if(this.selectedLeaveSpan == 'Multiple' && (!this.leave.start_date || !this.leave.end_date)) return;
      else this.leaveAllowanceStats = null;
      var url = Helper.addUrlParams(endpoints.getLeaveStatsForApplying, [`start_date=${this.leave.start_date}`, ...(this.leave.end_date ? [`end_date=${this.leave.end_date}`] : []), `staff_id=${this.leave.staff_id}`, `leave_type=${this.leave.leave_type}`, `is_half_day=${this.leave.is_half_day}`,]);
      this.leaveAllowanceStats = await api.call(this.apiEssentials, url);
      
    },
    // gets all the holidays inside allowance's range
    async getRangeHolidays() {
      this.staffHolidays = await api.call(this.apiEssentials, Helper.addUrlParams(endpoints.staffHolidays, ['start_date=' + this.staffLeaveAllowance.validity[0], 'end_date=' + this.staffLeaveAllowance.validity[1]]));
    },

    async submitLeaveDetails() {
      var body = {
        leave: this.leave,
        is_editing: false,
      }
      
      var response = await api.call(this.apiEssentials, endpoints.staffLeaves, api.Methods.POST, body);
      if(response) {
        this.$router.push({ name: "LeaveDetails", query: {staff_id: response.staff.id}, params: { month: moment(response.start_date).month(), year: moment(response.start_date).year() }});
      }
    },

    getDateEvents(date) {
      var weekOffExists = false;
      var holidayExists = false;
      if(this.staffLeaveAllowance.category.weekoffs.map(a => (a + 1) % 7).includes(moment(date).day())) weekOffExists = true;
      if(this.staffHolidays.find(sh => sh.date == date)) holidayExists = true;

      if(weekOffExists && holidayExists) return ['green', 'blue'];
      if(weekOffExists && !holidayExists) return ['green'];
      if(!weekOffExists && holidayExists) return ['blue'];
      // const [,, day] = date.split('-')
      // if ([12, 17, 28].includes(parseInt(day, 10))) return true
      // if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false
    },
  },

  watch: {
    'leave.start_date': function(){
      this.leave.end_date = null;
    }
  },

  async created() {
    // get staff details through api

    this.getAllLeaveTypes();
    await this.getAllStaff();


    if(Object.prototype.hasOwnProperty.call(this.$route.query,'staff_id')){
        this.leave.staff_id = Number(this.$route.query.staff_id);
    }
    this.handleTour();

  },

 

};
</script>

<style scoped>
	.card-title {
		font-size: 1rem;
		text-decoration: underline;
	}
</style>
